// biome-ignore-all lint/style/useNamingConvention: allow camel case

export enum VariantType {
  PREMIUM = 'premium',
  FREE = 'free',
}

export type TemplateAssets = {
  '250x340': string;
  '250x340_optimized': string;
  '372x372': string;
  '496x372': string;
  '500x680': string;
  '500x680_optimized': string;
  '600x600': string;
  '800x600': string;
  medium_gallery_asset: string;
  small_gallery_asset: string;
  _hash: string;
  [key: string]: string;
};

export type TemplatePositionPercent = {
  left: number;
  top: number;
  height: number;
  width: number;
};

export type UyoImagePosition = {
  left: number;
  top: number;
  width: number;
  height: number;
  scaleX: number;
  scaleY: number;
};

export type Template = {
  altTag: string;
  artist: string;
  assets: Record<string, TemplateAssets>;
  badge: string | null;
  categories: string[];
  colors: string[];
  displayName: string;
  dyo: boolean;
  eventTitleColor: string | null;
  eventType: string;
  favorite: boolean;
  height: number;
  informationColor: string | null;
  invitationTypes: string[] | null;
  keywords: string[];
  metaDescription: string;
  popularity: number;
  pos: number;
  premium: boolean;
  templateId: string;
  templatePositionPercent: TemplatePositionPercent;
  usedAs: string;
  uyo: boolean;
  uyoImagePosition: UyoImagePosition;
  versionName?: string;
  width: number;
};

export type TemplateSet = {
  backgrounds?: Array<{
    media?: Array<{
      url: string;
    }>;
  }>;
  liners?: Array<{
    media?: Array<{
      url: string;
    }>;
  }>;
  envelopes?: Array<{
    blank?: string;
    flap_down_image?: string;
  }>;
};
